export default [
    {
        field: 'uf',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UF ($)',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'utm',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UTM ($)',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
    {
        field: 'uta',
        type: 'float',
        value: '',
        vuetifyProps: {
            label: 'UTA ($)',
        },
        format: 'currency',
        rules: [ 'required', 'isNotNegative' ],
    },
]
